module.exports = __webpack_public_path__ + "static/media/group_26@3x.3e8cf58b.png";